import { render, staticRenderFns } from "./carbonsaeureester.vue?vue&type=template&id=3d06ed4c&"
import script from "./carbonsaeureester.vue?vue&type=script&lang=js&"
export * from "./carbonsaeureester.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports